import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

export default class TBLProdutos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 0,
      page: 0,
      limit: 10,
      loading: false,
    };

    this.columns = [
      {
        Header: "SKU",
        accessor: this.props.isItemPedido ? "item.sku" : "sku",
      },
      {
        Header: "Corredor",
        accessor: this.props.isItemPedido
          ? "item.categoria.corredor.nome"
          : "categoria.corredor.nome",
        className: "center",
      },
      {
        Header: "Categoria",
        accessor: this.props.isItemPedido ? "item.categoria.nome" : "categoria.nome",
        className: "center",
      },
      {
        Header: "Produto",
        accessor: this.props.isItemPedido ? "item.nome" : "nome",
      },
      {
        Header: this.props.isItemPedido ? "Preço unitário" : "Preço original",
        accessor: this.props.isItemPedido ? "preco_unitario" : "preco.preco_original", // Custom value accessors!,
        Cell: (props) => (
          <span>{props.value ? "R$ " + this.formatPreco(props.value) : "-"}</span>
        ),
        className: "right",
      },
      {
        Header: this.props.isItemPedido ? "Preço total" : "Preço encarte",
        accessor: this.props.isItemPedido ? "preco_total" : "preco.preco_encarte", // Custom value accessors!,
        Cell: (props) => (
          <span>{props.value ? "R$ " + this.formatPreco(props.value) : "-"}</span>
        ),
        className: "right",
      },
      {
        Header: "Quantidade",
        accessor: "quantidade",
        Cell: (props) => <span>{props.value ? this.formatPreco(props.value) : "-"}</span>,
        className: "right",
      },
      {
        Header: "Peso",
        accessor: this.props.isItemPedido ? "item.peso" : "peso",
        Cell: (props) => <span>{this.convertToPeso(props.value)}</span>,
        className: "right",
      },
      {
        Header: "Tipo da embalagem",
        accessor: this.props.isItemPedido ? "item.tipo_embalagem" : "tipo_embalagem",
        className: "right",
      },
    ];
    this.acoes = [
      {
        Header: "Ações",
        Cell: (row) => (
          <div>
            {this.props.isSelecao ? (
              <Button
                size="sm"
                style={{ marginRight: 4 }}
                onClick={() => this.gerenciarAcoes("selecionar", row.row._original)}
              >
                <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
              </Button>
            ) : (
              <>
                <Button
                  size="sm"
                  style={{ marginRight: 4 }}
                  onClick={() => this.gerenciarAcoes("editar", row.row._original)}
                >
                  <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
                >
                  <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                </Button>
              </>
            )}
          </div>
        ),
        className: "center",
      },
    ];
  }

  convertToPeso = (peso) => {
    if (peso < 1) {
      return (
        parseFloat(peso * 1000)
          .toFixed(0)
          .toString()
          .replace(".", ",") + "g"
      );
    } else {
      return parseFloat(peso).toFixed(2).toString().replace(".", ",") + "Kg";
    }
  };

  formatPreco = (valor) => {
    return parseFloat(valor).toFixed(2).replace(".", ",");
  };

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "selecionar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    const { data, pages, loading, showPagination, limit, changePage } = this.props;

    return (
      <ReactTable
        data={data}
        columns={this.props.showAcoes ? [...this.columns, ...this.acoes] : this.columns}
        resizable
        manual
        pages={pages}
        onPageChange={(page) => changePage(page + 1)}
        showPagination={showPagination}
        defaultPageSize={limit}
        loading={loading}
        style={{
          height: this.props.height || 572,
          maxHeight: 572,
        }}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando produtos..."
        noDataText="Nenhum produto encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLProdutos.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  dataCallback: PropTypes.func,
  arrayCallback: PropTypes.func,
  isItemPedido: PropTypes.bool,
  isItemPromocao: PropTypes.bool,
  showAcoes: PropTypes.bool,
  carregarDados: PropTypes.bool,
  height: PropTypes.number,
};
